import React from "react";
function ErrorFallback({ error }) {
    return (
        <div role="alert">
            <h2>Something went wrong</h2>
            {/* <pre style={{ color: 'red' }}>{error.message}</pre> */}
        </div>
    )
}

export default ErrorFallback